module.exports = __webpack_public_path__ + "static/media/source-sans-pro-v13-latin-600.c85615b2.woff2";